import type { DayCol } from "./build-days.js";
import { TimeAxisGrid } from "./TimeAxisGrid.js";

interface Props {
  /** WIDE, stable day window (the single visible day + buffer columns). */
  days: DayCol[];
  windowStart: Date;
  visibleStart: Date;
  onDayShift?: (delta: number) => void;
  onDayCountChange?: (delta: number) => void;
}

export function DayGrid({ days, windowStart, visibleStart, onDayShift, onDayCountChange }: Props) {
  return (
    <TimeAxisGrid
      days={days}
      windowStart={windowStart}
      visibleStart={visibleStart}
      visibleCount={1}
      {...(onDayShift ? { onDayShift } : {})}
      {...(onDayCountChange ? { onDayCountChange } : {})}
    />
  );
}
